<template>
      <div class="the-team-page-container">
        <TheTeamInfo />
        <section class="team container hidden">
            <h1>Ontmoet onze mensen</h1>
            <div class="row-custom">
                <!-- Tandartsen -->
                <MemberCard :name="'Milad Rahatianpur'"
                            :branche="'Tandarts<br>BIG nummer: 49925905302'"
                            :image="'milad-rahatianpur.jpg'"
                            :activeMember="'milad-rahatianpur'"/>
                <MemberCard :name="'Cecile van Beijnen'"
                            :branche="'Tandarts ZZP (extern)<br>BIG nummer: 09917092702'"
                            :image="'no-picture.png'"
                            :activeMember="'cecile-van-beijnen'"/>
                
                <!-- Mondhygiënisten -->
                <MemberCard :name="'Patty van Gogh'"
                            :branche="'Mondhygiëniste ZZP (extern)'"
                            :image="'no-picture.png'"
                            :activeMember="'patty-van-gogh'"/>
                <MemberCard :name="'Hosniya Qaderi'"
                            :branche="'Mondhygiëniste ZZP (extern)'"
                            :image="'no-picture.png'"
                            :activeMember="'hosniya-qaderi'"/>
                <MemberCard :name="'Melike Yilmaz'"
                            :branche="'Mondhygiëniste ZZP (extern)'"
                            :image="'no-picture.png'"
                            :activeMember="'melike-yilmaz'"/>
                
                <!-- Preventieassistente -->
                <MemberCard :name="'Miranda'"
                            :branche="'Preventieassistente'"
                            :image="'Miranda_Klein.png'"
                            :activeMember="'miranda-klein'"/>
                
                <!-- Assistente -->
                <MemberCard :name="'Danee Maenen'"
                            :branche="'Assistente'"
                            :image="'no-picture.png'"
                            :activeMember="'danee-maenen'"/>
             </div>
        </section>

      </div>

</template>

<script>
import MemberCard from '../components/MemberCard.vue';
import TheTeamInfo from '../components/TheTeamInfo.vue';


export default {
    name: "TheTeam",
    components: {
        MemberCard,
        TheTeamInfo
    },
    mounted(){
      this.$store.commit('updateActivePage', 'TheTeam')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          }
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Ons Team | Tandzorg Gestel | Tandartsen en Mondhygiënisten"
      document.querySelector('meta[name="description"]').setAttribute("content", "Maak kennis met ons professionele team van tandartsen, mondhygiënisten en assistentes bij Tandzorg Gestel in Sint-Michielsgestel.");
    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateX(0);
}

.the-team-page-container {
  margin-top: 75px;
  margin-bottom: 75px;
  /* background-color: #F2F2F2; */
}
.team {
    /* width: 80%; */
    margin: auto;
    text-align: center;
    padding: 0rem;
}
.team h1 {
    font-size: 25px;
}
.team p {
    font-size: 14px;
}
.team .row-custom {
    /* column-gap: 50px;
    margin-top: 50px; */
    /* background-color: red; */
  margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 40px;

}

@media(max-width: 991px) {
    .team .row-custom {
        margin-top: 20px;
    }
    .team h1 {
        font-size: 20px;
    }
    .team p {
        margin-bottom: 20px;
    }
    .team .row-custom {
        flex-direction: column;
        row-gap: 0px;
    }
    .the-team-page-container {
        margin-top: 55px;
        margin-bottom: 10px;
    }
}

</style>